import apiClient from '@shared/api/apiClient';

/**
 * 공휴일 목록 조회
 * GET /api/v1/holidays?year=YYYY
 */
async function getHolidayList(year) {
  const response = await apiClient.get('/v1/holidays', {
    params: { year },
    withAuth: true,
  });

  return response.data;
}

export { getHolidayList };
